import { css } from 'styled-components';

export const Outline = css`
  outline: 2px solid;
  outline-color: var(--primary-color);
  outline-offset: -2px;
`;

export const OutlineError = css`
  ${Outline};
  outline-color: var(--error-color);
`;
